/* less/lib/less/constants */ function _(require, module, exports) {
    module.exports = {
        Math: {
            ALWAYS: 0,
            PARENS_DIVISION: 1,
            PARENS: 2,
            STRICT_LEGACY: 3
        },
        RewriteUrls: {
            OFF: 0,
            LOCAL: 1,
            ALL: 2
        }
    };
}
